import axiosInstance from "./axios";

export interface BookingData {
    name: string;
    email: string;
    phone: string;
    company: string;
    industry: string;
    annualSales: string;
    website: string;
    hearAbout: string;
    start_time: string;
    message?: string;
    timezone?: string;
}

export interface AvailabilityResponse {
    date: string;
    available_slots: string[];
}

const calendlyService = {
    /**
     * Fetches available time slots for a given date and timezone.
     */
    getAvailability: async (date: string, timezone: string): Promise<AvailabilityResponse> => {
        try {
            const response = await axiosInstance.get<AvailabilityResponse>(`/api/calendly/availability`, {
                params: { date, timezone }
            });
            return response.data;
        } catch (error: any) {
            console.error("Error fetching availability:", error);
            throw error.response?.data || error.message;
        }
    },

    /**
     * Fetches available time slots for a range of dates.
     */
    getAvailabilityRange: async (start: string, end: string, timezone: string): Promise<{ available_dates: string[] }> => {
        try {
            const response = await axiosInstance.get<{ available_dates: string[] }>(`/api/calendly/availability/range`, {
                params: { start, end, timezone }
            });
            return response.data;
        } catch (error: any) {
            console.error("Error fetching range availability:", error);
            throw error.response?.data || error.message;
        }
    },

    /**
     * Submits a booking request to the backend.
     */
    createBooking: async (data: BookingData): Promise<any> => {
        try {
            const response = await axiosInstance.post(`/api/calendly/bookings`, data);
            return response.data;
        } catch (error: any) {
            console.error("Error creating booking:", error);
            throw error.response?.data || error.message;
        }
    }
};

export default calendlyService;
